import {useState} from "react";
import PreferenceSettings from "./PreferenceSettings";
import RateTypeSetting from "./RateTypeSetting";
import TaxTypeSetting from "./TaxTypeSetting";
import ExpenseCategorySetting from "./ExpenseCategorySetting";
import ColorSetting from "./ColorSetting";

const Setting = () => {
    const [currentTab, setCurrentTab] = useState(0);
    return (
        <div className="row">
            <div className="col-xl-3 col-md-4">
                <div className="card">
                    <div className="card-body">
                        <div className="page-header">
                            <div className="content-page-header">
                                <h5>Settings</h5>
                            </div>
                        </div>
                        <div className="widget settings-menu mb-0">
                            <ul>
                                <li className="nav-item" onClick={() => {
                                    setCurrentTab(0);
                                }}>
                                    <a href="javascript:void(0);" className={`nav-link ${currentTab == 0 ? 'active' : ''}`}>
                                        <i className="fe fe-user"></i> <span>Preferences</span>
                                    </a>
                                </li>
                                <li className="nav-item" onClick={() => {
                                    setCurrentTab(1);
                                }}>
                                    <a href="javascript:void(0);" className={`nav-link ${currentTab == 1 ? 'active' : ''}`}>
                                        <i className="fe fe-settings"></i> <span>Tax Types</span>
                                    </a>
                                </li>
                                <li className="nav-item" onClick={() => {
                                    setCurrentTab(2);
                                }}>
                                    <a href="javascript:void(0);" className={`nav-link ${currentTab == 2 ? 'active' : ''}`}>
                                        <i className="fe fe-file"></i> <span>Expenses Category</span>
                                    </a>
                                </li>
                                <li className="nav-item" onClick={() => {
                                    setCurrentTab(3);
                                }}>
                                    <a href="javascript:void(0);" className={`nav-link ${currentTab == 3 ? 'active' : ''}`}>
                                        <i className="fe fe-layers"></i> <span>Rate Types</span>
                                    </a>
                                </li>
                                <li className="nav-item" onClick={() => {
                                    setCurrentTab(4);
                                }}>
                                    <a href="javascript:void(0);" className={`nav-link ${currentTab == 4 ? 'active' : ''}`}>
                                        <i className="fe fe-layout"></i> <span>Colors</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-9 col-md-8">
                {
                    currentTab === 0 && <PreferenceSettings/>
                }
                {
                    currentTab === 1 && <TaxTypeSetting/>
                }
                {
                    currentTab === 2 && <ExpenseCategorySetting/>
                }
                {
                    currentTab === 3 && <RateTypeSetting/>
                }
                {
                    currentTab === 4 && <ColorSetting/>
                }
            </div>
        </div>

    )
}

export default Setting;
